import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  // Contract Signing (public - no auth required)
  {
    key: "contract-sign",
    path: `/contract/sign/:token`,
    component: React.lazy(() => import("views/app-views/codeforce/contracts/ContractSign")),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
];

export const protectedRoutes = [
  // ================== CODEFORCE CRM ROUTES ==================
  // Dashboard
  {
    key: "codeforce-dashboard",
    path: `${APP_PREFIX_PATH}/codeforce/dashboard`,
    component: React.lazy(() => import("views/app-views/codeforce/dashboard")),
  },
  
  // Clients
  {
    key: "codeforce-clients",
    path: `${APP_PREFIX_PATH}/codeforce/clients`,
    component: React.lazy(() => import("views/app-views/codeforce/clients")),
  },
  {
    key: "codeforce-clients-add",
    path: `${APP_PREFIX_PATH}/codeforce/clients/add`,
    component: React.lazy(() => import("views/app-views/codeforce/clients/AddClient")),
  },
  {
    key: "codeforce-clients-edit",
    path: `${APP_PREFIX_PATH}/codeforce/clients/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/clients/AddClient")),
  },
  {
    key: "codeforce-clients-detail",
    path: `${APP_PREFIX_PATH}/codeforce/clients/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/clients/ClientDetail")),
  },
  
  // Projects
  {
    key: "codeforce-projects",
    path: `${APP_PREFIX_PATH}/codeforce/projects`,
    component: React.lazy(() => import("views/app-views/codeforce/projects")),
  },
  {
    key: "codeforce-projects-add",
    path: `${APP_PREFIX_PATH}/codeforce/projects/add`,
    component: React.lazy(() => import("views/app-views/codeforce/projects/AddProject")),
  },
  {
    key: "codeforce-projects-edit",
    path: `${APP_PREFIX_PATH}/codeforce/projects/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/projects/AddProject")),
  },
  {
    key: "codeforce-projects-detail",
    path: `${APP_PREFIX_PATH}/codeforce/projects/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/projects/ProjectDetail")),
  },
  
  // Payments
  {
    key: "codeforce-payments",
    path: `${APP_PREFIX_PATH}/codeforce/payments`,
    component: React.lazy(() => import("views/app-views/codeforce/payments")),
  },
  {
    key: "codeforce-payments-add",
    path: `${APP_PREFIX_PATH}/codeforce/payments/add`,
    component: React.lazy(() => import("views/app-views/codeforce/payments/AddPayment")),
  },
  {
    key: "codeforce-payments-edit",
    path: `${APP_PREFIX_PATH}/codeforce/payments/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/payments/AddPayment")),
  },
  
  // Contracts
  {
    key: "codeforce-contracts",
    path: `${APP_PREFIX_PATH}/codeforce/contracts`,
    component: React.lazy(() => import("views/app-views/codeforce/contracts")),
  },
  {
    key: "codeforce-contracts-add",
    path: `${APP_PREFIX_PATH}/codeforce/contracts/add`,
    component: React.lazy(() => import("views/app-views/codeforce/contracts/AddContract")),
  },
  {
    key: "codeforce-contracts-edit",
    path: `${APP_PREFIX_PATH}/codeforce/contracts/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/contracts/AddContract")),
  },
  
  // Servers
  {
    key: "codeforce-servers",
    path: `${APP_PREFIX_PATH}/codeforce/servers`,
    component: React.lazy(() => import("views/app-views/codeforce/servers")),
  },
  
  // Company Settings
  {
    key: "codeforce-settings",
    path: `${APP_PREFIX_PATH}/codeforce/settings`,
    component: React.lazy(() => import("views/app-views/codeforce/settings")),
  },
  
  // CMS
  {
    key: "codeforce-cms",
    path: `${APP_PREFIX_PATH}/codeforce/cms`,
    component: React.lazy(() => import("views/app-views/codeforce/cms")),
  },
  {
    key: "codeforce-cms-add",
    path: `${APP_PREFIX_PATH}/codeforce/cms/add`,
    component: React.lazy(() => import("views/app-views/codeforce/cms/AddContent")),
  },
  {
    key: "codeforce-cms-edit",
    path: `${APP_PREFIX_PATH}/codeforce/cms/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/cms/AddContent")),
  },

  // Tasks
  {
    key: "codeforce-tasks",
    path: `${APP_PREFIX_PATH}/codeforce/tasks`,
    component: React.lazy(() => import("views/app-views/codeforce/tasks")),
  },
  {
    key: "codeforce-tasks-add",
    path: `${APP_PREFIX_PATH}/codeforce/tasks/add`,
    component: React.lazy(() => import("views/app-views/codeforce/tasks/AddTask")),
  },
  {
    key: "codeforce-tasks-edit",
    path: `${APP_PREFIX_PATH}/codeforce/tasks/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/tasks/AddTask")),
  },
  {
    key: "codeforce-tasks-detail",
    path: `${APP_PREFIX_PATH}/codeforce/tasks/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/tasks/AddTask")),
  },

  // Estimates
  {
    key: "codeforce-estimates",
    path: `${APP_PREFIX_PATH}/codeforce/estimates`,
    component: React.lazy(() => import("views/app-views/codeforce/estimates")),
  },
  {
    key: "codeforce-estimates-add",
    path: `${APP_PREFIX_PATH}/codeforce/estimates/add`,
    component: React.lazy(() => import("views/app-views/codeforce/estimates/AddEstimate")),
  },
  {
    key: "codeforce-estimates-edit",
    path: `${APP_PREFIX_PATH}/codeforce/estimates/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/estimates/AddEstimate")),
  },
  {
    key: "codeforce-estimates-detail",
    path: `${APP_PREFIX_PATH}/codeforce/estimates/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/estimates/AddEstimate")),
  },

  // Invoices
  {
    key: "codeforce-invoices",
    path: `${APP_PREFIX_PATH}/codeforce/invoices`,
    component: React.lazy(() => import("views/app-views/codeforce/invoices")),
  },
  {
    key: "codeforce-invoices-add",
    path: `${APP_PREFIX_PATH}/codeforce/invoices/add`,
    component: React.lazy(() => import("views/app-views/codeforce/invoices/AddInvoice")),
  },
  {
    key: "codeforce-invoices-edit",
    path: `${APP_PREFIX_PATH}/codeforce/invoices/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/invoices/AddInvoice")),
  },
  {
    key: "codeforce-invoices-detail",
    path: `${APP_PREFIX_PATH}/codeforce/invoices/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/invoices/AddInvoice")),
  },

  // Notes
  {
    key: "codeforce-notes",
    path: `${APP_PREFIX_PATH}/codeforce/notes`,
    component: React.lazy(() => import("views/app-views/codeforce/notes")),
  },
  {
    key: "codeforce-notes-add",
    path: `${APP_PREFIX_PATH}/codeforce/notes/add`,
    component: React.lazy(() => import("views/app-views/codeforce/notes/AddNote")),
  },
  {
    key: "codeforce-notes-edit",
    path: `${APP_PREFIX_PATH}/codeforce/notes/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/notes/AddNote")),
  },
  {
    key: "codeforce-notes-detail",
    path: `${APP_PREFIX_PATH}/codeforce/notes/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/notes/AddNote")),
  },

  // Leads
  {
    key: "codeforce-leads",
    path: `${APP_PREFIX_PATH}/codeforce/leads`,
    component: React.lazy(() => import("views/app-views/codeforce/leads")),
  },
  {
    key: "codeforce-leads-add",
    path: `${APP_PREFIX_PATH}/codeforce/leads/add`,
    component: React.lazy(() => import("views/app-views/codeforce/leads/AddLead")),
  },
  {
    key: "codeforce-leads-edit",
    path: `${APP_PREFIX_PATH}/codeforce/leads/edit/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/leads/AddLead")),
  },
  {
    key: "codeforce-leads-detail",
    path: `${APP_PREFIX_PATH}/codeforce/leads/:id`,
    component: React.lazy(() => import("views/app-views/codeforce/leads/AddLead")),
  },
];
